const styles = {
  tag: {
    color: '#fff',
    padding: 4,
    fontSize: 9,
    margin: 2,
    borderRadius: 2,
    backgroundColor: 'rgb(51, 122, 183)',
    display: 'inline-block',
    cursor: 'pointer',
    outline: 0,
    maxWidth: 'calc(100% - 12px)',
    wordWrap: 'break-word'
  },
  pinnedTag: {
    paddingRight: 2
  },
  flash: {
    backgroundColor: 'orange',
    transition: 'background 0.5s ease'
  },
  deleteEnter: {
    backgroundColor: '#d9534f'
  },
  pinnedEnter: {
    backgroundColor: 'rgb(20, 81, 135)'
  },
  cross: {
    marginLeft: 1,
    color: '#fff',
    padding: 2,
    fontSize: 11,
    cursor: 'pointer'
  },
  pinnedCross: {
    width: 0,
    fontSize: 11,
    display: 'inline-block'
  }
}

export default styles
